// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as NavMenu__Items$Showside from "../components/NavMenu/NavMenu__Items.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as NavMenu__Topbar$Showside from "../components/NavMenu/NavMenu__Topbar.bs.js";
import * as NavMenu__Context$Showside from "../components/NavMenu/NavMenu__Context.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as NavMenu__Hamburger$Showside from "../components/NavMenu/NavMenu__Hamburger.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as MiniCartDrawer_Lazy$Showside from "../components/MiniCartDrawer_Lazy.bs.js";
import * as NavMenuOverlay_Lazy$Showside from "../pages/NavMenuOverlay_Lazy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function NavMenuApp(Props) {
  var embedType = Props.embedType;
  var attributes = Props.attributes;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match$1.previewMode;
  var goTo = match$1.goTo;
  var route = match$1.route;
  LocationConfig$Showside.use(undefined);
  var items = NavMenu__Items$Showside.useItems(undefined, undefined);
  var match$2 = React.useState(function () {});
  var setContentHeight = match$2[1];
  var contentHeight = match$2[0];
  var exitTimeoutRef = React.useRef(undefined);
  var handleMouseLeave = React.useCallback(function ($$event) {
    Belt_Option.forEach(exitTimeoutRef.current, function (prim) {
      clearTimeout(prim);
    });
    exitTimeoutRef.current = Caml_option.some(setTimeout(function (param) {
      if (typeof route === "number") {
        return;
      }
      switch (route.TAG | 0) {
        case /* Home */0:
        case /* ListPage */1:
          break;
        default:
          return;
      }
      if (Caml_obj.notequal(previewMode, /* PreviewHead */0)) {
        return Curry._3(goTo, undefined, undefined, /* NotRendered */0);
      }
    }, 50));
  }, [goTo]);
  var handleMouseEnter = React.useCallback(function ($$event) {
    Belt_Option.forEach(exitTimeoutRef.current, function (prim) {
      clearTimeout(prim);
    });
  }, [goTo]);
  var match$3 = ctx.mode;
  var tmp;
  if (match$3) {
    var tmp$1 = {};
    if (items !== undefined) {
      tmp$1.items = Caml_option.valFromOption(items);
    }
    tmp = React.createElement(NavMenu__Hamburger$Showside.make, tmp$1);
  } else {
    var tmp$2 = {
      enableHiddenLinkTree: true,
      onMouseLeave: handleMouseLeave,
      onMouseEnter: handleMouseEnter
    };
    if (items !== undefined) {
      tmp$2.items = Caml_option.valFromOption(items);
    }
    tmp = React.createElement(NavMenu__Topbar$Showside.make, tmp$2);
  }
  var match$4 = ctx.mode;
  var tmp$3 = {
    config: config,
    embedType: embedType,
    children: React.createElement(ErrorBoundary$Showside.make, {
      componentName: "NavMenuApp",
      children: null
    }, tmp, React.createElement(BaseWithTheme$Showside.make, {
      initiator: "nav-menu-app",
      portal: true,
      children: match$4 ? React.createElement(NavMenuOverlay_Lazy$Showside.make, {
        contentHeight: contentHeight,
        setContentHeight: setContentHeight
      }) : React.createElement(NavMenuOverlay_Lazy$Showside.make, {
        contentHeight: contentHeight,
        setContentHeight: setContentHeight,
        onMouseLeave: handleMouseLeave,
        onMouseEnter: handleMouseEnter
      })
    }), React.createElement(ConditionalRender$Showside.When.make, {
      condition: config.settings.cart,
      children: React.createElement(MiniCartDrawer_Lazy$Showside.make, {})
    }))
  };
  if (attributes !== undefined) {
    tmp$3.attributes = Caml_option.valFromOption(attributes);
  }
  return React.createElement(EntrypointCallbacks$Showside.make, tmp$3);
}
NavMenuApp.displayName = "NavMenuApp";
var make = React.memo(NavMenuApp);
var $$default = make;
export { make, $$default, $$default as default };
/* make Not a pure module */